module.exports = __webpack_public_path__ + "img/Other Pizza.4baea47b.svg";